import { Person20Regular } from '@/components/Icon'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import PlanUsageCardShell from './PlanUsageCardShell'
import { PlanUsageTokenMeter } from './PlanUsageTokenMeter'

/**
 * @param {{ usedFraction?: number, usedLabel?: string, capLabel?: string, percentLabel?: string }} props
 */
export default function PlanUsageTokenAllowanceCard({
  usedFraction = 0.4,
  usedLabel = '4M',
  capLabel = '10M',
  percentLabel = '40%',
}) {
  return (
    <PlanUsageCardShell sectionAriaLabel="Token usage and allowance" title="Token allowance" titleIcon={<Person20Regular />} intro={getSettingsSectionIntro('plan-tokens')}>
      <PlanUsageTokenMeter usedFraction={usedFraction} usedLabel={usedLabel} capLabel={capLabel} percentLabel={percentLabel} />
    </PlanUsageCardShell>
  )
}
